<div fxLayout="column" fxLayoutGap="24px">
  <section>
    <div fxLayout fxLayoutAlign="start center">
      <h3 fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="6px" class="nomargin">
        <span>Resync data from</span>
        <div fxLayoutAlign="start center" fxLayoutGap="4px">
          <sbnb-icon-airbnb></sbnb-icon-airbnb>
          <span>Airbnb</span>
        </div>
      </h3>
      <sbnb-close (click)="dialogRef.close()"></sbnb-close>
    </div>
  </section>

  <p>
    Any unedited fields are periodically refreshed from Airbnb. You can manually refresh these now to ensure your
    property data on any Direct Sites are up to date.
  </p>

  <div class="flex items-center" data-tour="resync-unlinked-fields">
    <input
      type="checkbox"
      id="syncUnlinked"
      [(ngModel)]="syncUnlinkedFields"
      class="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
    >
    <label for="syncUnlinked" class="ml-2 text-sm text-gray-700">
      Also synchronise unlinked fields
    </label>
  </div>

  <div fxLayout fxLayoutAlign="end center" fxLayoutGap="8px">
    <sbnb-button label="Cancel" [disabled]="resyncing" type="secondary" (clicked)="dialogRef.close()"></sbnb-button>
    <sbnb-button label="Resync now" [loading]="resyncing" (clicked)="resync()"></sbnb-button>
  </div>
</div>
